import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_119_add_labour_others: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Add Labour/Others",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "item_master_add",
        TableName: "item_master",
        columnNumber: "m1 t1 w3",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        childComponents: [
          // Part no. (required)
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_parts",
            label: "Part no.",
            placeholder: "Part no / item code",
            required: true,
            inputType: InputType.TEXT,
            Json_Attribute: "part_no",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Part no. is required",
              },
            ],
          },
          // Item group - Select with labour_others lookup
          {
            componentType: ComponentType.SELECT_DROPDOWN,
            name: "drp_group",
            label: "Item group",
            placeholder: "--Not Set--",
            required: false,
            lookupName: "labour_others",
            options: [],
            Json_Attribute: "parent_id",
          },
          // Item name
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_itemname",
            label: "Item name",
            placeholder: "",
            required: false,
            inputType: InputType.TEXT,
            Json_Attribute: "item_name",
          },
          // Origin - Search_Select with country lookup
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "s_search__orign",
            label: "Origin",
            placeholder: "",
            required: false,
            lookupName: "country",
            options: [],
            searchable: true,
            clearable: true,
            Json_Attribute: "origin",
          },
          // Rack/Bin
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_rackbin",
            label: "Rack/Bin",
            placeholder: "",
            required: false,
            inputType: InputType.TEXT,
            Json_Attribute: "rack_bin",
          },
          // Remarks
          {
            componentType: ComponentType.TEXT_AREA,
            name: "txt_itemremarks",
            label: "Remarks",
            placeholder: "",
            required: false,
            Json_Attribute: "remarks",
          },
          // Unit - Select with measurementunit lookup
          {
            componentType: ComponentType.SELECT_DROPDOWN,
            name: "s_search_itemunit",
            label: "Unit",
            placeholder: "--Not Set--",
            required: false,
            lookupName: "measurementunit",
            options: [],
            Json_Attribute: "unit",
          },
          // Department - Search_Select with department lookup
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "s_search_departments",
            label: "Department",
            placeholder: "",
            required: false,
            lookupName: "department",
            options: [],
            searchable: true,
            clearable: true,
            Json_Attribute: "department_id",
          },
          // Purchase rate - Numeric
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_purchase_rate",
            label: "Purchase rate",
            placeholder: "",
            required: false,
            inputType: InputType.NUMBER,
            defaultValue: "0.00",
            Json_Attribute: "purchase_rate",
          },
          // Sale rate - Numeric
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_sale_rate",
            label: "Sale rate",
            placeholder: "",
            required: false,
            inputType: InputType.NUMBER,
            defaultValue: "0.00",
            Json_Attribute: "sale_rate",
          },
          // Sales account
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_sales_acc",
            label: "Sales account",
            placeholder: "",
            required: false,
            inputType: InputType.TEXT,
            Json_Attribute: "sales_account",
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Save",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];
